import firebase from 'firebase';

export const dbParent = (parentName = 'projects') => {
  return firebase.firestore().collection(parentName);
};

export const listAllCollection = async (name, projectId) => {
  const response = await dbParent().doc(projectId).collection(name).get();
  const result = [];
  await response.forEach((subDoc) => {
    result.push({...subDoc.data(), __id: subDoc.id});
  });
  return result;
};


export const insertMultiple = async (data, collection, replaceFieldId) => {
  const batch =  firebase.firestore().batch();
  const ids = {};
  const docRefs = []
  data.forEach((doc) => {
    const docRef = collection.doc();

    if(doc.__id) {
      ids[doc.__id] = docRef.id;
      delete doc.__id;
    }

    docRefs.push(docRef)
  });

  docRefs.forEach((ref, index) => {
    if(replaceFieldId && data[index][replaceFieldId]) {
      data[index][replaceFieldId] = ids[data[index][replaceFieldId]];
    }

    batch.set(ref, data[index]);
  })

  await batch.commit();

  return ids;
};



// WEBPACK FOOTER //
// ./src/firestore/utils.js